const AdditionalAmenity = ({ amenity = '', id = '', isEditable = false }) => ({
  amenity: String(amenity),
  id: String(id),
  isEditable: Boolean(isEditable),
});

const AmenityValue = ({ displayName = '', fieldName = '', isSelected = '' }) => ({
  displayName: String(displayName),
  fieldName: String(fieldName),
  isSelected: Boolean(isSelected),
});

const GenericAmenity = ({
  category = '',
  isEditable = false,
  isRequired = false,
  isUniqueSelection = false,
  values = [],
}) => ({
  category: String(category),
  isEditable: Boolean(isEditable),
  isRequired: Boolean(isRequired),
  isUniqueSelection: Boolean(isUniqueSelection),
  values: values.map(AmenityValue),
});

const Amenities = ({ additional = [], interior = [], property = [] } = {}) => ({
  additional: additional.map(AdditionalAmenity),
  interior: interior.map(GenericAmenity),
  property: property.map(GenericAmenity),
});

export default Amenities;

export type AmenitiesProps = ReturnType<typeof Amenities>;
